import React from "react";

import { Button, IconButton, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useTheme } from "@material-ui/core/styles";

import SimpleDialog from "components/SimpleDialog";

import { useAppDispatch } from "store";
import { cancelUpload } from "modules/customer/data/dataSlice";

const DeleteFile: React.FC = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDeleteClick = () => {
        setOpen(true);
    };

    const handleYesClick = () => {
        dispatch(cancelUpload());
    };

    const handleNoClick = () => {
        setOpen(false);
    };

    return (
        <>
            <IconButton onClick={handleDeleteClick} style={{ color: theme.palette.text.disabled }}>
                <DeleteIcon fontSize="inherit" />
            </IconButton>
            <SimpleDialog
                open={open}
                onClose={handleNoClick}
                title={
                    <>
                        <Typography variant="h1" component="div" color="error" gutterBottom>
                            <ErrorOutlineIcon fontSize="inherit" color="inherit" />
                        </Typography>
                        <Typography variant="h5" component="div" gutterBottom>
                            Are you sure you would like to delete this file?
                        </Typography>
                    </>
                }
                titleAlign="center"
                content={
                    <>
                        <Typography variant="subtitle1" component="div">
                            The file will be deleted permanently.
                        </Typography>
                    </>
                }
                contentAlign="center"
                actions={
                    <>
                        <Button
                            variant="outlined"
                            size="large"
                            color="default"
                            disableElevation
                            onClick={handleYesClick}
                        >
                            Yes, delete file
                        </Button>
                        <Button
                            variant="contained"
                            size="large"
                            color="primary"
                            disableElevation
                            onClick={handleNoClick}
                        >
                            No, keep file
                        </Button>
                    </>
                }
                actionsJustifyContent="center"
            />
        </>
    );
};

export default DeleteFile;
